import { v4 as uuidv4 } from 'uuid';

export function AcceptedPaymentMethods(props) {
	return {
		componentName: 'AcceptedPaymentMethods',
		componentId: uuidv4(),
		props: {
			paymentMethods: ['mastercard', 'visa', 'diners club'],
			showInColor: false,
			...props,
		},
		childrenComponents: [],
	};
}
